<template>
  <div 
  v-ripple
  :class="['c-flex-c mrow']">
    
    <div class="c-flex-r1 pt-1 pb-1">

      <div class="c-flex-r1 pl-2 pr-2">

        <v-layout align-center class="c-flex-00a">
          <transition
          name="slide-x-transition"
          mode="out-in">

            <v-btn
            v-if="selectedCount > 0"
            icon
            text
            @click.stop="$emit('checkRow', item)">
              <v-icon :color="selected[item.id] ? 'color1' : ''"> 
                {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
              </v-icon>
            </v-btn>

          </transition>

          <transition
          name="slide-x-transition"
          appear
          hide-on-leave
          mode="out-in">
            <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
          </transition>

          <img class="pl-1" src="@/assets/img/illustrations/recipe.png" alt="cardboard box" width="32px">
        </v-layout>

        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="red"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>
        

        <div class="c-flex-r1 ml-2 align-start">

          <div class="c-flex-c1">
            <div class="caption">
              {{ build.name }}
              <span v-if="build.deleted_at" class="red--text">
                (deleted)
              </span>
            </div>
            <div 
            v-if="build.net_weight"
            class="caption text--text text--darken-1">
              Net weight: 
              <c-ms-ii
              :realValue="build.net_weight"
              sid="si-mass-g"
              :alwaysScale="true"
              :key="build.id"
              labelMode
              ></c-ms-ii>

            </div>
          </div>

        </div>

      </div>

      <v-menu @click.native.stop
      offset-x left 
      content-class="menu-override"
      transition="slide-x-reverse-transition">
        <template v-slot:activator="{ on }">
          <v-btn
            text
            icon
            v-on="on"
            @click.stop
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-layout>
          <div class="menu-div">
            <v-btn
            icon text
            class="ma-0"
            @click="$emit('checkRow', item)">
              <v-icon color="white"> 
                {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
              </v-icon>
            </v-btn>
            <v-btn icon text @click="clickIt($event, item.id)" class="ma-0">
              <v-icon color="white">mdi-delete-outline</v-icon>
            </v-btn>
          </div>
          <div class="triangle"></div>
        </v-layout>
      </v-menu>

      <confirm-menu ref="confirmMenu"></confirm-menu>

    </div>

    <div class="local-border-bottom"></div>

  </div>
</template>

<script>
import ConfirmMenu from '@/components/dialogs/ConfirmMenu'
export default {
  props: ['item', 'itemsMeta', 'selected', 'selectedCount'],
  components: {
    ConfirmMenu
  },
  data () {
    return {
      // 5
    }
  },
  computed: {
    build () {
      return this.item
    }
  },
  methods: {
    clickIt (event, id) {
      this.$refs.confirmMenu.open(event.clientX, event.clientY, 'Delete this build?').then((confirm) => {
        if (confirm) {
          this.$emit('onDelete', [id])
        }
      })
      // this.$emit('onDelete', id)
      console.log(event)
    }
  }
}
</script>

<style scoped lang="scss">
.menu-override {
  box-shadow: none;
  background: transparent;
  border-radius: 0px;
}
.triangle {
  width: 12px;
  height: 12px;
  background: var(--v-background-base);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: -6px;
  margin-right: 2px;
  margin-top: 10px;
}
.menu-div {
  border-radius: 2px;
  background: var(--v-background-base);

  /* &:before {
    content: "";
    display: block;
    width: 12px;
    height: 12px;
    position: absolute;
    right: 2px;
    background: var(--v-color1-base);
    top: 12px;
    transform: rotate(45deg);
  } */
}
</style>
